import { SearchInput } from "@/ui/inputs/Input";
import { useState, useEffect, useRef } from "react";
import useTableService from "../useTableServerSide";
import axios from "axios";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import Footer from "../Footer";
import moment from "moment";
import ModalSecuenciaPlantilla from "./ModalSecuenciaPlanilla";
const headCells = [
  {
    id: "0",
    label: "SECUENCIA",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "1",
    label: "FECHA",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "2",
    label: "NRO PLANILLA",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "3",
    label: "ORDEN PAGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "4",
    label: "FISCAL",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
  {
    id: "5",
    label: "OPCIONES",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
  },
];

export default function TablaSecuenciaPlanilla(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const searchTimeoutRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectItem, setSelectItem] = useState();
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };
  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
    onSortChange: (orderBy, orderDir) =>
      setTableState((prev) => ({ ...prev, orderBy, orderDir, page: 0 })),
  };
  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );
  const buscarRegistros = () => {
    setLoading(true);
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      idEfiscal: idefiscal,
    };
    const endpoint = `${op.conexion}/api/administracion/buscar-secuencia-planilla`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };
  const cerrar = () => {
    props.setTabla(0);
  };
  useEffect(() => {
    const cleanup = buscarRegistros();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState]);
  return (
    <div className="col-12 my-4 py-5">
      <div className="col-8 m-0 p-2 border rounded mx-auto">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
          <h3 className="fw-bold text-light m-0 text-uppercase">
            Secuencia Planilla
          </h3>
          <button onClick={() => cerrar()} className="btn btn-sm bg-light">
            <i className="fa fa-times"></i>
          </button>
        </header>
        <div className="col-4 m-0 my-2 p-0">
          <SearchInput
            className="search-input pe-4"
            value={searchInput}
            onChange={handleSearch}
          />
        </div>
        <section className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                records.map((item, index) => (
                  <tr key={index} style={{ padding: "0" }}>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      {item.secuencia}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      {moment(item.fecharet).format("DD/MM/YYYY")}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      {item.numeroplanilla}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      {item.numordenpago}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      {item.idefiscal}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      <button
                        className="btn btn-sm btn-warning rounded-pill"
                        onClick={() => {
                          setSelectItem(item);
                          setShowModal(true);
                        }}
                      >
                        <i className="fa fa-edit"></i>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </section>
      </div>
      <ModalSecuenciaPlantilla
        show={showModal}
        onHidde={() => setShowModal(false)}
        planilla={selectItem}
        actualizarPlantilla={() => buscarRegistros()}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
